import { useState } from 'react';
import { Link } from 'react-router-dom';
import { Alert, Button, Input } from 'antd';
import { SplitShell } from '../layout/split/SplitShell';
import styles from '../layout/split/split.module.css';
import { ApiError, accountsApi } from '../api';

/** /forgot — request a password-reset link by email. Server never confirms
 *  whether the address exists (no enumeration).                            */
export function ForgotPage() {
  return <SplitShell><ForgotForm /></SplitShell>;
}

function ForgotForm() {
  const [email, setEmail] = useState('');
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [sent, setSent] = useState(false);

  async function submit(e: React.FormEvent) {
    e.preventDefault();
    if (busy || !email) return;
    setBusy(true); setError(null);
    try {
      await accountsApi.forgot({ email });
      setSent(true);
    } catch (err) {
      setError(err instanceof ApiError
        ? (err.body as { message?: string } | null)?.message ?? err.message
        : err instanceof Error ? err.message : String(err));
    } finally { setBusy(false); }
  }

  return (
    <div>
      <div className={styles.stepHead}>
        <h2 className={styles.stepTitle}>Reset your password</h2>
        <p className={styles.stepSubtitle}>
          Enter your email. If we have an account for you, we'll send a reset link.
        </p>
      </div>

      <form className={styles.fields} onSubmit={submit} style={{ marginTop: 22 }}>
        <div className={styles.field}>
          <label className={styles.label} htmlFor="forgot-email">Email</label>
          <Input id="forgot-email" size="large" type="email" autoComplete="email"
            placeholder="you@example.in" value={email} onChange={(e) => setEmail(e.target.value)} />
        </div>
        {error && <Alert type="error" showIcon message={error} closable onClose={() => setError(null)} />}
        {sent && (
          <Alert type="success" showIcon message="Check your inbox"
            description={`If an account exists for ${email}, a reset link is on its way. The link is valid for 60 minutes.`} />
        )}
        <Button type="primary" htmlType="submit" size="large" block loading={busy} disabled={!email || sent}>
          Send reset link
        </Button>
      </form>

      <p className={styles.altAction}>
        Remembered it? <Link to="/login">Back to sign-in</Link>
      </p>
    </div>
  );
}
